



import EventReceptComponent from "@/components/admin/event/eventReceptComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "EventReceptPage",
  components: {
    EventReceptComponent,
  },
})
export default class EventReceptPage extends Vue {}
